const QueryKeys = {
  user: 'user',
  users: 'users',
  'datapoints-search': 'datapoints-search',
  'widget-config': 'widget-config',
  'widget-config-internal': 'widget-config-internal',
  siteMeta: 'site-meta',
  groups: 'groups',
  events: 'events',
  'user-groups': 'user-groups',
  'default-stack': 'default-stack',
  masterTracker: 'master-tracker',
  trackers: 'trackers',
  controlModeTemplates: 'control-mode-templates',
  controllerLockMode: 'control-lock-mode',
  stacks: 'stacks',
  notes: 'notes',
  auditLogs: 'audit-logs',
  alerts: 'alerts',
  alertConfigs: 'alert-configs',
  pointConfigs: 'point-configs',
  widgets: 'widgets',
  devices: 'devices',
  devicesFiltered: 'devicesFiltered',
};

export default QueryKeys;
